import {
    CONFIRMED_CREATE_BANNER_ACTION,
    CONFIRMED_DELETE_BANNER_ACTION,
    CONFIRMED_EDIT_BANNER_ACTION,
    CONFIRMED_GET_BANNERS,
    CREATE_BANNER_ACTION,
    ERROR_BANNER_ACTION,
    CLEAR_BANNER_ERROR
} from '../actions/BannerTypes';

const initialState = {
    banners: [],
    createBannerError:{}
};

export default function BannersReducer(state = initialState, actions) {
    if (actions.type === CREATE_BANNER_ACTION) { 

        const banners = [...state.banners];
        
        return {
            ...state,
            banners,
        };
    }

    if (actions.type === CONFIRMED_DELETE_BANNER_ACTION) {
        const banners = [...state.banners];
        const postIndex = banners.findIndex(
            (post) => post.id === actions.payload,
        );

        banners.splice(postIndex, 1);

        return {
            ...state,
            banners,
        };
    }

    if (actions.type === CONFIRMED_EDIT_BANNER_ACTION) {
        const banners = [...state.banners];
        const postIndex = banners.findIndex(
            (post) => post.id === actions.payload.id,
        );

        banners[postIndex] = actions.payload;
        return {
            ...state,
            banners,
        };
    }

    if (actions.type === CONFIRMED_CREATE_BANNER_ACTION) {
        const banners = [...state.banners];
        banners.push(actions.payload);

        return {
            ...state,
            banners,
        };
    }

    if (actions.type === CONFIRMED_GET_BANNERS) {
        return {
            ...state,
            banners: actions.payload,
        };
    }
    if (actions.type === ERROR_BANNER_ACTION) {
        return {
            ...state,
            createBannerError: actions.payload,
        };
    }

    if (actions.type === CLEAR_BANNER_ERROR) {
        return {
            ...state,
            createBannerError: {},
        };
    }
    return state;
}


